export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/provider-card.7a0dbb84-8beecc.svg";